import { decodeToken as decodePortableToken } from '@mh-wms/auth';

const STORAGE_KEY = 'wms.token';

/**
 * Token storage.
 *
 * localStorage is readable by any script on the origin, so a successful XSS
 * steals the session. The safer option (httpOnly cookie) is not available: the
 * backend issues a bearer token in a JSON body and validates the Authorization
 * header, with no cookie or CSRF handling. Changing that is a backend decision,
 * so this is a deliberate constraint rather than an oversight.
 */
export function getToken(): string | null {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null; // private mode / storage disabled
  }
}

export function setToken(token: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, token);
  } catch {
    /* non-fatal: the session lasts until reload */
  }
}

export function clearToken(): void {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** Browser storage and base64 decoding stay local; claim parsing is portable. */
export function decodeToken(token: string) {
  return decodePortableToken(token, atob);
}

export { isExpired } from '@mh-wms/auth';
export type { TokenClaims } from '@mh-wms/auth';
